// src/components/ErrorPage.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const message = searchParams.get('message') || 'An error occurred';
  const statusCode = searchParams.get('statusCode') || '500';

  return (
    <div className='min-h-screen bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 flex items-center justify-center px-4 sm:px-6 lg:px-8'>
      <div className='max-w-lg w-full space-y-8 bg-white p-10 rounded-xl shadow-2xl'>
        <div>
          <svg
            className='mx-auto h-24 w-24 text-red-500'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
            />
          </svg>
          <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
            Oops! Error {statusCode}
          </h2>
          <p className='mt-2 text-center text-sm text-gray-600'>{message}</p>
        </div>
        <div className='mt-8 space-y-6'>
          {/* <button
            onClick={() => navigate(-1)}
            className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
          >
            Go Back
          </button> */}
          <button
            onClick={() => navigate('/owner/dashboard')}
            className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
// // src/components/ErrorPage.js
// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const ErrorPage = ({ message, statusCode }) => {
//   const navigate = useNavigate();

//   return (
//     <div className='flex flex-col items-center justify-center min-h-screen bg-gray-100'>
//       <h1 className='text-4xl font-bold mb-4'>Error {statusCode}</h1>
//       <p className='text-xl mb-8'>{message}</p>
//       <button
//         onClick={() => navigate('/dashboard')}
//         className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
//       >
//         Go to Dashboard
//       </button>
//     </div>
//   );
// };

// export default ErrorPage;
